export enum EButtonKitType {
  DEFAULT = 'default',
  HOVER_PRIMARY = 'hover_primary',
  PRIMARY = 'primary',
  PRIMARY_HIGHLIGHT = 'primary_highlight',
  DANGER = 'danger',
  DANGER_HIGHLIGHT = 'danger_highlight',
}
